import { useMutation } from '@tanstack/react-query'

import { createCloudflareDocument } from '@flecto/api/saas'

type MutationPayload = {
  file: File
  signal: AbortSignal
}

export function useMutationCreateCloudflareDocument() {
  return useMutation({
    mutationKey: ['MutationCreateCloudflareDocument'],
    mutationFn: async ({ file, signal }: MutationPayload) => {
      const response = await createCloudflareDocument(file, { signal })
      return response
    },
  })
}
